import { Component } from "react";
import { Link } from "react-router-dom";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";

class BlogSlider extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let customClass = this.props.customClass ? this.props.customClass : "";
    let sectionClass = this.props.sectionClass ? this.props.sectionClass : "";
    const { blog, lang, loading } = this.props.appData;
    const blogs = Array.isArray(blog?.blogs) ? blog.blogs : [];
    return (
      <div className={"ltn__blog-area pt-100 pb-70 go-top " + sectionClass}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6
                  className={
                    "section-subtitle ltn__secondary-color " + customClass
                  }
                ></h6>
                <h1 className="section-title">
                  {lang === "tr" ? "Haberler" : "News"}
                </h1>
              </div>
            </div>
          </div>
          {!loading && blog && (
            <div className="row  ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
              {blogs.map((item, i) => {
                const t =
                  item?.translations?.[lang] ||
                  item?.translations?.tr ||
                  item?.translations?.en ||
                  {};

                const slug = clean(item?.slug);
                const title = clean(t.title);
                const bgPath = clean(item?.cover);
                const bg = bgPath ? fileUrl(API_FILE_URL, bgPath) : null;
                // Tarihi dile göre formatla
                const dateObj = item?.date ? new Date(item.date) : null;
                const formattedDate = dateObj
                  ? dateObj.toLocaleDateString(lang, {
                      year: "numeric",
                      month: "short", // kısa ay ismi (Oct, Eki vs.)
                      day: "numeric",
                    })
                  : "";
                return (
                  <div key={item?.id ?? i} className="col-lg-12">
                    <div className="ltn__blog-item ltn__blog-item-3">
                      <div className="ltn__blog-img">
                        <Link to={`/haber/${slug}`}>
                          <img
                            src={bg || publicUrl + "assets/img/blog/1.jpg"}
                            alt="#"
                            style={{
                              objectFit: "contain",
                              height: "200px",
                              width: "100%",
                            }}
                          />
                        </Link>
                      </div>
                      <div className="ltn__blog-brief">
                        <div className="ltn__blog-meta">
                          <ul>
                            <li className="ltn__blog-author">
                              <Link to={`/haber/${slug}`}>
                                <i className="far fa-user" />
                                Safkar
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <h3 className="ltn__blog-title blog-title-limit">
                          <Link to={`/haber/${slug}`}>
                            {title || "Blog Title Here"}
                          </Link>
                        </h3>
                        <div className="ltn__blog-meta-btn">
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <i className="far fa-calendar-alt" />
                                {formattedDate}
                              </li>
                            </ul>
                          </div>
                          <div
                            className="ltn__blog-btn"
                            style={{ textTransform: "none" }}
                          >
                            <Link to={`/haber/${slug}`}>
                              {lang === "tr" ? "Devamını Gör" : "Read More"}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withAppData(BlogSlider);
